import {
	Notification
} from "element-ui";
import store from "../store";
// 记录加载初始化状态
let isSdkReady = false;

// 记录加载配置状态
let isConfig = false;

export default class {
	// 初始化
	static init() {
		ysf("onready", function() {
			isSdkReady = true;
		});
		console.log("初始化");
	}

	// 配置客户参数
	static Config() {
		console.log(JSON.parse(localStorage.getItem("MenusData")).TrueName, '名称1');
		// console.log(localStorage.getItem("comm-token"),'Token');
		// console.log(JSON.parse(localStorage.getItem("MenusData")).UserName,'MenusData');
		ysf("config", {
			uid: JSON.parse(localStorage.getItem("MenusData")).UserName,
			name: JSON.parse(localStorage.getItem("MenusData")).TrueName,
			authToken: localStorage.getItem("comm-token"),
			data: JSON.stringify([{
				key: "real_name",
				value: JSON.parse(localStorage.getItem("MenusData")).TrueName,
			}, ]),
			success: function() {
				isConfig = true;
				// console.log(this.$store.state.userInfo.TrueName,'名称');
			},
		});
	}

	// 打开客服链接
	static openSdk() {
		console.log(isSdkReady, isConfig);
		if (isSdkReady && isConfig) {
			ysf("open");
			console.log("打开客服链接");
		} else {
			ysf("open");
			// Notification.error({
			//   title: "提示",
			//   message: "sdk尚未加载成功，请重新登录再试！",
			//   duration: 0,
			// });
		}
	}
	// 退出&&客服链接
	static closeSdk() {
		isSdkReady = false;
		isConfig = false;
		ysf('logoff')
		console.log("退出客服链接");
	}
	// 监听
	static wacthSdk() {
		ysf("onunread", function(result) {
			// todo
			console.log(result.total, result.type, result.message, "hhhh");
			store.commit("WACTH_QY_Sdk", result.total);
			if (result.message != undefined && result.message != '') {
				Notification.warning({
					title: "客服消息",
					message: result.message,
					duration: 10000,
				});
			}
		});

		// 获取
		// var result = ysf("getUnreadMsg");
		// console.log(result.total, result.type, result.message, result, "22222");
		// localStorage.setItem("NoMessage", result.total);
	}
}